module.exports = __webpack_public_path__ + "img/slider_galery_13.a3db52ac.jpg";